import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title: 'WITHDRAWALS',
    asset: 'Asset',
    amount: 'Withdrawal amount',
    initiated: 'Initiated',
  },
};
